export { reducer as flyerGridReducer } from './screens/FlyerGrid/redux.js'
export { reducer as flyerDetailReducer } from './screens/FlyerDetail/redux.js'



// WEBPACK FOOTER //
// ./src/screens/Flyers/redux.js